<template>
  <v-dialog v-model="confirmDialog" max-width="500">
    <v-card>
      <v-card-title class="red white--text">
        <v-icon class="mr-3 white--text">mdi-close-circle</v-icon>
        {{ $t('shooting.deleteShooting.title') }}
      </v-card-title>

      <v-card-text class="pa-7 text--primary">
        {{ $t('shooting.deleteShooting.textPrimary') }}
      </v-card-text>

      <v-card-text class="px-7 font-weight-black">
        {{ $t('shooting.deleteShooting.textSecondary') }}
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined rounded @click="deleteImages">{{ $t('shooting.deleteShooting.yes') }}</v-btn>
        <v-btn color="primary" rounded @click="closeDialog">{{ $t('shooting.deleteShooting.no') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'DeleteShootingConfirmationModal',
  props: {
    dialog: {
      required: true,
      type: Boolean
    }
  },
  data: () => ({
    confirmDialog: false
  }),
  watch: {
    dialog: {
      handler(val) {
        this.confirmDialog = val
      }
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close-dialog')
    },

    deleteImages() {
      this.$emit('delete-images')
    }
  }
}
</script>
